import FiltersModal from "modals/FiltersModal";

export function handleFiltersEvents() {
    let $form = $(".js-filters-form");
    if ($form.length === 0) {
        return;
    }

    $form.closest(".admin-filters").hide();

    $("body").on("click", ".js-show-filters-modal", () => {
        let modal = new FiltersModal($form);
        modal.show();
        return false;
    })
}
